module.exports = __webpack_public_path__ + "static/media/mayank-pachpande.fd8fa04d.jpg";